import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { SessionInvalidationImpl } from "../model/impl/SessionInvalidationImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class SessionInvalidationImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: SessionInvalidationImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.connectionSessionId != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        SessionInvalidationImplEncoder.fidTypeMap.get(2),
        false,
        encodable.connectionSessionId,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        SessionInvalidationImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.sessionOnly != null) {
      this.baseEncoder.writeStartFid(10010, streamout);
      this.baseEncoder.writeObject(
        false,
        SessionInvalidationImplEncoder.fidTypeMap.get(10010),
        false,
        encodable.sessionOnly,
        streamout,
      );
      this.baseEncoder.writeEndFid(10010, streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [2, "java.lang.String"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: SessionInvalidationImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            SessionInvalidationImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.connectionSessionId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            SessionInvalidationImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            SessionInvalidationImplEncoder.fidTypeMap.get(10010),
            streamin,
          );
          encodable.sessionOnly = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return SessionInvalidationImplEncoder.fidTypeMap.has(fid);
  }
}
